import { frequencyOptions } from '../constants/generals'

const getFrecuencyText = (key: number) => {
  const f = frequencyOptions.find(fr => fr.value === key)
  if (f) {
    return f.text
  }
  return ''
}

export {
  getFrecuencyText
}
